import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const PRICE_AMOUNT = /^\d+(\.\d{1,2})?$/;

export const dxFreightSettings = defineIntegrationSettings({
  fields: {
    accountNumber: z.string().trim().min(1, "Account number is required"),
    serviceCentre: z.string().trim().min(1, "Service centre is required"),
    contactPhone: z.string().trim().min(1, "Contact phone is required"),
    collectionPrice: z.object({
      amount: z
        .string()
        .trim()
        .regex(PRICE_AMOUNT, "Enter the collection price, e.g. 25.00")
        .refine((amount) => Number(amount) > 0, {
          message: "Collection price must be more than 0",
        }),
      currency: createEnum(Currency),
    }),
  },
  secrets: { password: z.string().min(1, "Password is required") },
  connectOnly: {},
  computed: { id: z.string(), redoCarrierAccountId: z.string() },
});
